import React from 'react';

import { useTranslation } from '@lt/localization';
import { Link } from '@lt/components';
import styles from './resetPasswordForm.module.css';
import { Title } from '../Title';
import { Description } from '../Description';
import { Content } from '../Content';
import { EmailButton } from '../EmailButton';

interface Props {
  email: string;
  isRestore?: boolean;
  handleGoBack: () => void;
}

export const ResetPasswordForm: React.FC<Props> = ({
  email,
  isRestore,
  handleGoBack,
}) => {
  const { t } = useTranslation();
  return (
    <div className={styles.passwordForm}>
      <Title className={styles.title}>
        {t('checkout.passwordForm.reset.title')}
      </Title>
      <Description className={styles.description}>
        {t('checkout.passwordForm.reset.description', {
          context: isRestore ? 'setting' : 'reset',
          mail: email,
        })}
      </Description>
      <Description className={styles.description}>
        {t('checkout.passwordForm.reset.description')}
      </Description>
      <Content>
        <EmailButton email={email} />
        <Link
          className={styles.goBackLink}
          href="/"
          onClick={(e) => {
            e.preventDefault();
            handleGoBack();
          }}
        >
          {t('checkout.passwordForm.reset.goBack')}
        </Link>
      </Content>
    </div>
  );
};
